import { Users } from 'lucide-react';

const Team = () => {
  const facultyCoordinators = [
    {
      name: "TBD",
      role: "Faculty Co-ordinator",
    },
    {
      name: "TBD",
      role: "Faculty Co-ordinator",
    },
    {
      name: "TBD",
      role: "Faculty Co-ordinator",
    }
  ];

  const coreTeam = [
    {
      name: "TBD",
      role: "PRESIDENT-STRATEGY",
    },
    {
      name: "TBD",
      role: "PRESIDENT-EXTERNAL AFFAIRS",
    },
    {
      name: "TBD",
      role: "Tech Lead",
    },
    {
      name: "TBD",
      role: "Design Lead",
    },
    {
      name: "TBD",
      role: "Finance Lead",
    },
    {
      name: "TBD",
      role: "PR Lead",
    }
  ];

  return (
    <div className="pt-20" data-testid="team-page">
      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">THE PEOPLE BEHIND KAROBAR</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>OUR TEAM</h1>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">Meet the passionate individuals driving KAROBAR's mission forward.</p>
          </div>

          <div className="mb-24">
            <h2 className="text-3xl font-black mb-12 text-gold-500 text-center" style={{ fontFamily: 'Open Sans' }}>FACULTY CO-ORDINATORS</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {facultyCoordinators.map((member, index) => (
                <div key={index} className="glass-card p-8 text-center" data-testid={`faculty-member-${index}`}>
                  <div className="w-32 h-32 mx-auto mb-6 rounded-full bg-gradient-to-br from-gold-500/20 to-gold-600/10 flex items-center justify-center">
                    <Users className="w-16 h-16 text-gold-500" />
                  </div>
                  <h3 className="text-xl font-black mb-2" style={{ fontFamily: 'Open Sans' }}>{member.name}</h3>
                  <p className="text-gold-500 text-sm font-semibold tracking-wider">{member.role}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-black mb-12 text-center" style={{ fontFamily: 'Open Sans' }}>CORE TEAM</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
              {coreTeam.map((member, index) => (
                <div key={index} className="glass-card p-6 text-center" data-testid={`core-team-member-${index}`}>
                  <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-gradient-to-br from-gold-500/20 to-gold-600/10 flex items-center justify-center">
                    <Users className="w-10 h-10 text-gold-500" />
                  </div>
                  <h3 className="text-sm font-black mb-2" style={{ fontFamily: 'Open Sans' }}>{member.name}</h3>
                  <p className="text-gold-500 text-xs tracking-wider">{member.role}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Team;